import hogan from 'hogan.js';

import jobExperience from '../templates/jobexperience.html';
import education from '../templates/education.html';
import classification from '../templates/classification.html';
import clsDropdown from '../templates/clsdropdown.html';
import languageSkill from '../templates/languageskill.html';
import attachment from '../templates/attachment.html';

const clsLabel = hogan.compile('<span value="{{value}}" class="label container"><i class="fa fa-times-circle button-icon" aria-hidden="true"></i>  {{text}}</span> ');

const templates = {
  jobExperience, education, languageSkill, classification, clsDropdown, clsLabel, attachment,
};

export default templates;
